import React from 'react'
import { Control, Controller } from 'react-hook-form'
import { Dropdown, Field, makeStyles, Option } from '@fluentui/react-components'
import { t } from 'i18next'
import { IDropdownOption } from '../../interfaces/IDropdownOption'

const useStyles = makeStyles({
   dropdown: {
      width: '100%',
      minWidth: '0px',
   },
})

type ControlledDemandModulesDropdownProps = {
   name: string
   control: Control<any>
   label: string
   options: IDropdownOption[]
   disabled?: boolean
   required?: boolean
   defaultValue?: string
}

export const ControlledDemandModulesDropdown = ({ name, control, label, options, disabled, required, defaultValue }: ControlledDemandModulesDropdownProps) => {
   const classes = useStyles()
   return (
      <Controller
         name={name}
         control={control}
         rules={{ required: required ? t('RequiredField') : false }}
         render={({ field: { value, onChange }, fieldState: { error } }) => {
            const selectedOption = options.find((x) => x.key === value)

            return (
               <Field label={label} required={required ?? false} validationMessage={error ? error.message : null} validationState={error ? 'error' : null}>
                  <Dropdown
                     className={classes.dropdown}
                     value={selectedOption ? String(selectedOption.text) : defaultValue || ''}
                     onOptionSelect={(e, d) => {
                        const newValue = d.optionValue === value?.toString() ? null : d.optionValue
                        onChange(newValue)
                     }}
                     selectedOptions={value ? [value.toString()] : []}
                     disabled={disabled ?? false}
                  >
                     {options.map((x) => (
                        <Option key={x.key} value={x.key.toString()} disabled={x.disabled || false}>
                           {x.text.toString()}
                        </Option>
                     ))}
                  </Dropdown>
               </Field>
            )
         }}
      />
   )
}
